import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { BusyBlocker } from '@bingads-webui-react/wizard-ui-library';

export const ProcessingBlocker = ({ children }) => {
  const i18n = useContext(I18nContext);
  const loadingText = i18n.getString(_TL_('Processing...'));

  return (
    <BusyBlocker loadingText={loadingText}>
      {children}
    </BusyBlocker>
  );
};

ProcessingBlocker.propTypes = {
  children: PropTypes.node.isRequired,
};
